// extracted by mini-css-extract-plugin
export var attachment = "_so-a";
export var emailContainer = "_so-4";
export var emailContentPaddedContainer = "_so-b";
export var emailHeader = "_so-6";
export var emailIframe = "_so-3";
export var emailInfoIcon = "_so-9";
export var emailShortenedSummary = "_so-e";
export var infoDropdown = "_so-0";
export var infoRowBoundedContent = "_so-d";
export var internal = "_so-5";
export var merchant = "_so-8";
export var messageInputContainer = "_so-h";
export var normal = "_so-7";
export var replyCard = "_so-f";
export var subtleButton = "_so-1";
export var subtleButtonIconContainer = "_so-2";
export var toggleViewRepliesButton = "_so-c";
export var wrappingText = "_so-g";